import { render } from "./invoiceDetail.vue?vue&type=template&id=5661a177&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"

import "./invoiceDetail.vue?vue&type=style&index=0&id=5661a177&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./invoiceDetail.vue?vue&type=style&index=1&id=5661a177&lang=scss"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5661a177"]])

export default __exports__